import { ConfigProps } from '@config/types'

const config = ({ staticAssetPageUrl, staticPageUrlSuffix }: ConfigProps) =>
  ({
    hearkenUrl: 'https://modules.wearehearken.eu/blick-ch/embed/{hearkenId}.js',
    widgetUrl: `${staticAssetPageUrl}/hearken${staticPageUrlSuffix}`,
  }) as const satisfies Record<string, unknown>

export default config
